import { Chip, Theme } from "@mui/material";
import { alpha, darken } from "@mui/material/styles";
import { useTenantTranslation } from "hooks/formatters";
import { StandbyState } from "src/store/api/generatedApi";

/** Amber is too light to read a label on, so the flag darkens it. */
const coveringTextColor = (theme: Theme) =>
  darken(theme.palette.warning.main, 0.6);

const coveringBackgroundColor = (theme: Theme) =>
  alpha(theme.palette.warning.main, 0.28);

export const StandbyFlag = ({
  standbyState,
}: {
  standbyState: StandbyState | null | undefined;
}) => {
  const { t } = useTenantTranslation();

  if (!standbyState) return null;

  const isCovering = standbyState === "covering";

  return (
    <Chip
      label={isCovering ? t("standbyCovering") : t("standby")}
      title={isCovering ? t("standbyCoveringTooltip") : t("standbyTooltip")}
      size="small"
      variant={isCovering ? "filled" : "outlined"}
      sx={{
        fontWeight: "fontWeightBold",
        letterSpacing: 0.4,
        textTransform: "uppercase",
        ...(isCovering
          ? {
              bgcolor: coveringBackgroundColor,
              color: coveringTextColor,
              borderColor: "warning.main",
            }
          : {
              color: "text.secondary",
              borderColor: "grey.300",
            }),
      }}
    />
  );
};
